export default __webpack_public_path__ + "static/media/Redhelp.557911c1.svg";